import React from "react"

import { useLanguage } from "locales"

import styles from "./PharmaSupportContact.module.scss"

// Support contact block shown at the bottom of the pharmacy professional screens
const PharmaSupportContact: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const { languages } = useLanguage()
  return (
    <div className={styles.Contact} style={style}>
      {languages.pharmaSupportIntro}
      <br />
      <span>
        {languages.pharmaSupportFrom} <b>{languages.pharmaSupportDays} </b>
        {languages.pharmaSupportHoursPrefix} <b>{languages.pharmaSupportHours}</b>
      </span>
      <br />
      <span>
        {languages.pharmaSupportPhonePrefix} <b>{languages.pharmaSupportPhone}</b>
      </span>
      <br />
      <span>
        {languages.pharmaSupportEmailPrefix} <b>{languages.pharmaSupportEmail}</b>
      </span>
    </div>
  )
}

export default PharmaSupportContact
